import { ref, onMounted, onBeforeUnmount } from "vue";

export function useHeroMouse(heroRef) {
  const isHovering = ref(false);

  const handleMove = (event) => {
    const el = heroRef.value;
    if (!el) return;

    const rect = el.getBoundingClientRect();
    const x = (event.clientX - rect.left) / rect.width;
    const y = (event.clientY - rect.top) / rect.height;

    isHovering.value = true;
    el.style.setProperty("--mx", x.toFixed(4));
    el.style.setProperty("--my", y.toFixed(4));
    el.style.setProperty("--cursor-x", `${event.clientX - rect.left}px`);
    el.style.setProperty("--cursor-y", `${event.clientY - rect.top}px`);
  };

  const handleLeave = () => {
    const el = heroRef.value;
    isHovering.value = false;
    if (!el) return;
    el.style.setProperty("--mx", "0.5");
    el.style.setProperty("--my", "0.5");
  };

  onMounted(() => {
    const el = heroRef.value;
    if (!el) return;
    el.style.setProperty("--mx", "0.5");
    el.style.setProperty("--my", "0.5");
    el.addEventListener("mousemove", handleMove);
    el.addEventListener("mouseleave", handleLeave);
  });

  onBeforeUnmount(() => {
    const el = heroRef.value;
    if (!el) return;
    el.removeEventListener("mousemove", handleMove);
    el.removeEventListener("mouseleave", handleLeave);
  });

  return { isHovering };
}
